module.exports = __webpack_public_path__ + "img/pocket_activation.f42e9450.svg";